module.exports = __webpack_public_path__ + "images/choices/masthead-9b077c904d420520313ba874821affc5.png";